
import TaskGenerator from "./components/task-generator"

export default function Page() {
  return <TaskGenerator />
}
